<template>
  <div v-cloak>
    <main>
      <v-card class="login-form">
        <v-form @submit.native.prevent="submit()">
          <v-text-field
            label="Email"
            v-model="formData.email"
            name="email"
            required
          ></v-text-field>
          <v-text-field
            label="Password"
            type="password"
            name="password"
            v-model="formData.password"
            required
          ></v-text-field>
          <v-layout row justify-space-between>
            <router-link tag="a" :to="{ name: 'forgotPassword' }">Forgot your password?</router-link>
            <v-btn type="submit" dark primary class="margin-off">
              <v-icon>arrow_forward</v-icon>
            </v-btn>
          </v-layout>
          <v-alert color="error" class="err" icon="warning" value="true" v-if="err">{{err}}</v-alert>
        </v-form>
      </v-card>
    </main>
  </div>
</template>

<script>
  import auth from '../auth';

  export default {
    data: () => ({
      formData: {
        email: '',
        password: '',
      },
      err: '',
    }),
    methods: {
      async submit() {
        if (!this.formData.email || !this.formData.password) {
          this.err = 'You must enter email and password';
          return;
        }
        const res = await auth.login(this, this.formData);
        if (res === null) {
          this.err = 'Failed to login. Please try again.';
          return;
        }
        this.$store.dispatch('setRole', res);
        if (res === 3) {
          this.$router.push({ name: 'suitesList' });
        } else {
          this.$router.push({ path: '/' });
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  [v-cloak] {
    display: none;
  }

  main {
    display: flex;
    align-items: center;
    max-width: 500px;
    margin: auto;
    height: 100vh;
  }

  .err {
    margin-bottom: 30px;
  }

  .margin-off {
    margin-right: 0;
  }

  .login-form {
    margin: 0 auto;
    width: 100%;
    padding: 50px 40px 20px 40px;
    a {
      margin-top: 12px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Login.vue